import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppRepository } from '@timechef/core/state';
import { LogLevel } from 'src/environments/environment-config';
import { StoreInspectorModalComponent } from '../store-inspector-modal/store-inspector-modal.component';

@Component({
  selector: 'app-logs-modal',
  templateUrl: './logs-modal.component.html',
  styleUrls: ['./logs-modal.component.scss'],
  standalone: false,
})
export class LogsModalComponent {
  logs$ = this.appRepo.logs$;
  LogLevel = LogLevel;

  constructor(
    private appRepo: AppRepository,
    private modalCtrl: ModalController,
  ) {}

  async dismissModal() {
    this.appRepo.setLogsAsShown();
    await this.modalCtrl.dismiss();
  }

  clearLogs() {
    this.appRepo.clearLogs();
  }

  async openStoreModal() {
    const modal = await this.modalCtrl.create({
      component: StoreInspectorModalComponent,
      initialBreakpoint: 1,
    });
    await modal.present();
  }
}
